const getStatus = (status: string | undefined): string => {
  if (!status) {
    return 'Ошибка'
  } else {
    switch (status) {
      case 'WaitPayment':
        return 'Ожидает оплату'

      case 'PaidBuyer':
        return 'Оплачен покупателем'

      case 'Done':
        return 'Завершен успешно'

      case 'Canceled':
        return 'Отменен'

      case 'Dispute':
        return 'Спор'

      default:
        return 'Ошибка';
    }
  }
}

export default getStatus